import { GeneralModel } from "./general.model";

export class Department extends GeneralModel {
    parrentDepartmentId?: any;
}